<template> 
  <li v-if="link.type!='item item-divider' && link.id !='75d987d2-ca1a-4842-ac84-4d0826d32951'"
      class="nav-item toolbar-link" @click="openSubLinkOrRedirect(link)"
      style="width: 200px;position:relative;margin-left: 10px">
    <a class="nav-link active" aria-current="page" data-bs-dismiss="offcanvas" style="min-width:300px"
       :style="{'color':'#000' + '!important'}">
      <i class="canvas-item-icon " :class="link.icon_style"
         v-if="link.id !=  '83d6e8e2-d6ec-487c-9ed2-d5f966cb90f8'"></i>
      <font-awesome-icon style="width:20px"
                         class="canvas-item-icon " :style="{color: tileBgColor}"
                         v-if="link.icon_fa " :icon="[link.icon_fa.type, link.icon_fa.name]"/>

      {{ link.title[currentLanguage] }}
    </a><span
      v-if="link.target == '#/app/posts' && unreadNews > 0"
      class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
      style="top:20px">
                {{ unreadNews }}
              </span>
  </li>
  <li v-if="link.type!='item item-divider' && link.id =='75d987d2-ca1a-4842-ac84-4d0826d32951'"
      class="nav-item toolbar-link"
      style="width: 200px;position:relative;margin-left: 10px">
    <a class="nav-link active" aria-current="page"  style="min-width:300px"
       :href="redirectLink" target="_blank"
       :style="{'color':'#000' + '!important'}">
      <i class="canvas-item-icon " :class="link.icon_style"
         v-if="link.id !=  '83d6e8e2-d6ec-487c-9ed2-d5f966cb90f8'"></i>
      <font-awesome-icon style="width:20px"
                         class="canvas-item-icon " :style="{color: tileBgColor}"
                         v-if="link.icon_fa " :icon="[link.icon_fa.type, link.icon_fa.name]"/>

      {{ link.title[currentLanguage] }}
    </a><span
      v-if="link.target == '#/app/posts' && unreadNews > 0"
      class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
      style="top:20px">
                {{ unreadNews }}
              </span>
  </li>


  <li v-if=" link.type=='item item-divider'" class="menu-divider " style="line-height: 1rem">
    <b> {{ link.title[currentLanguage] }} </b>
  </li>
  <hr v-if="link.sublinks.length > 0 && link.type=='item item-divider'">


</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
import {addIcons} from "ionicons";
import {
  personCircleOutline,
  chatbubbleOutline,
  syncOutline,
  logOutOutline,
  logInOutline,
  searchCircleOutline,
  homeOutline,
  chevronBackOutline,
  cloudOfflineOutline,
  menuOutline
} from "ionicons/icons";

addIcons({
  "sync-outline": syncOutline,
  "person-circle-outline": personCircleOutline,
  "log-out-outline": logOutOutline,
  "log-in-outline": logInOutline,
  "chatbubble-outline": chatbubbleOutline,
  "search-circle-outline": searchCircleOutline,
  "home-outline": homeOutline,
  "chevron-back-outline": chevronBackOutline,
  'cloud-offline-outline': cloudOfflineOutline,
  "menu-outline": menuOutline,
});
const config = require('@/config')
import router from '@/router';
import {alertController, isPlatform} from "@ionic/vue";

import {store} from "@/store";

export default {
  components: {},
  props: ['link'],
  data() {
    return {
      menulinks: [],
      menulinksTop: [],
      title: config.full_name,
      isConsultant: false,
      userConsultant: null,
      isDesktop: null,
      isIos: null,
      video_chat_enabled: false,
      confDate: config.conf_date,
      openSubBar: false,
      sublinks: null,
      time: null,
      appointmentsRole: null,
      searchterm: '',
      hideSearchBar: false,
      historyCount: 0,
      loginAlertOpen: false,
      onLine: navigator.onLine,
      showBackOnline: false,
    }
  },
  computed: {
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress']),
    ...mapGetters('auth', ['user', 'token']),
    ...mapState('splashscreen', ['showSplashscreen']),
    ...mapState('personalDB', ['unreadNews']),
    ...mapState('chat', ['currentChat', 'unreadTotal']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
    ...mapState('currentConference', ['currentConference', 'fullName', 'shortName', 'apiVersion', 'primaryColor', 'menuheader']),
    redirectLink: function () {
      return this.link.redirect + '?jwtoken=' + this.token;
    },
  },
  methods: {
    ...mapActions("settings", [
      "getSetting",
    ]),
    ...mapActions('sync', ['start']),
    ...mapActions("exhibitors", ["getAllExhibitors"]),
    ...mapActions('menulinks', ['isExternalLink']),
    ...mapActions('auth', ['GET_USERDATA', 'GENERATE_JWT']),
    ...mapMutations('splashscreen', ['setShowSplash', 'setShowHelp']),
    ...mapActions("personalDB", ["connectPersonalDB", 'getItem', 'getItems', 'prepareFavoriteList', 'setTime', 'getUnreadNews']),
    ...mapMutations('personalDB', ['setUnreadNews']),
    ...mapActions('chat', ['getUnreadMessagesTotalCount']),
    ...mapActions('googleanalytics', ['trackWithLabel']),

    async showHelpAgain() {
      localStorage.removeItem('helpSeen');
      this.setShowHelp(true);
    },

    goToChat() {
      if (this.user && this.user.id) {
        this.$router.push('/app/chat/');
      } else {
        this.chatAlert()
      }
    },

    async chatAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'You need to be logged in in order to access this content.',
            message: 'Do you want to log in?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'Confirm',
                id: 'confirm-button',
                handler: () => {
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    },
    async getRedirectLink(link) {
      let token = await this.GENERATE_JWT();
      return link.redirect + '?jwtoken=' + token
    },

    async openSubLinkOrRedirect(link) {
      this.trackWithLabel('menu_link:' + link.title.en)
      if (link.redirect == '/app/chat') {
        this.goToChat()
      } else {
        if (link.sublinks && link.sublinks.length > 0) {
          let external = await this.isExternalLink(link.target)
          if (external) {
            window.open(link.redirect, '_blank').focus();
          } else {
            router.push(link.redirect);
          }
        } else {
          let external = await this.isExternalLink(link.target)
          if (external) {
            window.open(link.redirect, '_blank').focus();
          } else {
               if(this.currentLanguage == 'fr' && link.redirect.includes('/app/generalinfo/')){
            if(link.redirect == '/app/generalinfo/45e5c2e4-2a6e-438c-a5e3-6adb6c5c19af'){
              router.push('/app/generalinfo/37c44157-fe04-4d46-81e9-7b4904d45eb5' )
            }
            if(link.redirect == '/app/generalinfo/867cc563-aad3-4152-a2d7-5fae37d47d34'){
              router.push('/app/generalinfo/867cc563-aad3-4152-a2d7-5fae37d47d34')
            }
        } else {
           router.push(link.redirect);
        }
          }
        }
      }
    

    },


    async login() {
      console.log("login")
      let self = this
      localStorage.setItem('lastPageBeforeLogin', location.hash);
      //let frontendKey = config.auth_key;
      if (isPlatform('ios') && typeof cordova != 'undefined') {
        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line

        let redirect = (param) => {
          if (param && param.indexOf('token=') != -1) {
            let token = param.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        }

        ref.addEventListener('loaderror', function (event) {
          ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
        ref.addEventListener('loadstart', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });



      } else if (isPlatform('android') && typeof cordova != 'undefined') {

        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key, '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line
        ref.addEventListener('loaderror', function (event) {

          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
      } else {
        console.log("essta")
        //window.location.href = "https://auth.documedias.com/application/" + config.auth_dev_key
        window.location.href = "https://auth.documedias.com/application/" + (process.env.NODE_ENV == 'production' ? config.auth_key : config.auth_dev_key) + '?logout=true'

      }

    },

     async loginByToken(tokenSent) {
      //check for token in path
      let token = tokenSent
      if (token) {

        localStorage.setItem("x-api-key", token);

        let userRequest = await store.dispatch("auth/GET_USERDATA");
        //this.user = userRequest.data;

        let tmpUser = userRequest.data;

        if (tmpUser) {

          await store.commit("auth/SET_USER", tmpUser);
          localStorage.setItem('user', JSON.stringify(tmpUser));
        }
        //splice the path
        window.history.pushState(
            {},
            document.title,
            '/'
        );
        router.push({name: 'Dashboard'});

      } else {
        router.next();
      }
      router.next();

    },

  },

  mounted() {
  },
  beforeUnmount() {
  },

  watch: {}

};
</script>

